module.exports = __webpack_public_path__ + "static/img/agb_4.18696f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/agb_4.png
// module id = 1245
// module chunks = 1